// import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './Layout'
// import KronoAvtal from "./KronoAvtal";

import Integritetspolicy from './Integritetspolicy'
import Anvandarvillkor from './Anvandarvillkor'
import StartPage from './StartPage'
import SharedListing from './SharedListing'
import siteLogo from './site_logo.png'
import Foretag from './Foretag'
import ForetagsAnnosering from './ForetagsAnnonsering'
import KronosSecure from './KronosSecure'
import KronosCertified from './KronosCertified'
import UnSubscribe from './UnSubscribe'
import Klockvardering from './Klockvardering'
import KronosCertifiedControl from './KronosCertifiedControl'
import Blog from './Blog'
import WatchBrands from './WatchBrands'
import RolexBrand from './RolexBrand'
import OmegaBrand from './OmegaBrand'
import BreitlingBrand from './BreitlingBrand'
import PaneraiBrand from './PaneraiBrand'
import LonginesBrand from './LonginesBrand'
import SeikoBrand from './SeikoBrand'
import CertinaBrand from './CertinaBrand'
import IwcBrand from './IwcBrand'
import CartierBrand from './CartierBrand'
import JaegerLeCoultreBrand from './JaegerLeCoultreBrand'
import ZenithBrand from './ZenithBrand'
import PatekPhilippeBrand from './PatekPhilippeBrand'
import AudemarsPiguetBrand from './AudemarsPiguetBrand'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<StartPage siteLogo={siteLogo} />} />
          <Route path="/annons/:id" element={<SharedListing siteLogo={siteLogo} />} />
          <Route path="/ad/:id" element={<SharedListing siteLogo={siteLogo} />} />
          <Route path="/klockmarken" element={<WatchBrands siteLogo={siteLogo} />} />
          <Route path="/rolex" element={<RolexBrand siteLogo={siteLogo} />} />
          <Route path="/omega" element={<OmegaBrand siteLogo={siteLogo} />} />
          <Route path="/breitling" element={<BreitlingBrand siteLogo={siteLogo} />} />
          <Route path="/panerai" element={<PaneraiBrand siteLogo={siteLogo} />} />
          <Route path="/longines" element={<LonginesBrand siteLogo={siteLogo} />} />
          <Route path="/seiko" element={<SeikoBrand siteLogo={siteLogo} />} />
          <Route path="/certina" element={<CertinaBrand siteLogo={siteLogo} />} />
          <Route path="/iwc" element={<IwcBrand siteLogo={siteLogo} />} />
          <Route path="/cartier" element={<CartierBrand siteLogo={siteLogo} />} />
          <Route path="/jaeger-lecoultre" element={<JaegerLeCoultreBrand siteLogo={siteLogo} />} />
          <Route path="/zenith" element={<ZenithBrand siteLogo={siteLogo} />} />
          <Route path="/patek-philippe" element={<PatekPhilippeBrand siteLogo={siteLogo} />} />
          <Route path="/audemars-piguet" element={<AudemarsPiguetBrand siteLogo={siteLogo} />} />
          {/* <Route
            path="/krono-avtal"
            element={<KronoAvtal siteLogo={siteLogo} />}
          /> */}
          <Route path="/kronos-secure" element={<KronosSecure siteLogo={siteLogo} />} />
          <Route path="/kronos-certified" element={<KronosCertified siteLogo={siteLogo} />} />
          <Route
            path="/kronos-certified-control"
            element={<KronosCertifiedControl siteLogo={siteLogo} />}
          />
          <Route path="/klockvardering" element={<Klockvardering siteLogo={siteLogo} />} />
          <Route path="/foretagsannonsering" element={<ForetagsAnnosering siteLogo={siteLogo} />} />
          <Route path="/marknadsforing" element={<Foretag siteLogo={siteLogo} />} />
          <Route path="/integritetspolicy" element={<Integritetspolicy siteLogo={siteLogo} />} />
          <Route path="/anvandarvillkor" element={<Anvandarvillkor siteLogo={siteLogo} />} />
          <Route path="/blogg" element={<Blog siteLogo={siteLogo} />} />

          <Route path="/unsubscribe" element={<UnSubscribe siteLogo={siteLogo} />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
